import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`gatsby-theme-system`}</h1>
    <p>{`A minimalist Gatsby theme based on constraint-based design principles`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i gatsby-theme-system
`}</code></pre>
    <h2>{`Features`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mdxjs.com"
        }}>{`MDX`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/system-ui/theme-ui"
        }}>{`Theme UI`}</a></li>
      <li parentName="ul">{`Customizable layout, colors & typography`}</li>
      <li parentName="ul">{`Built-in page layout component`}</li>
      <li parentName="ul">{`MDX header and footer content`}</li>
    </ul>
    <h2>{`Getting Started`}</h2>
    <p>{`In your `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`, add the theme:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    'gatsby-theme-system',
  ],
}
`}</code></pre>
    <h2>{`Theming`}</h2>
    <p>{`Shadow the `}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/index.js`}</inlineCode>{` file to customize the theme.`}</p>
    <h2>{`Header and Footer`}</h2>
    <p>{`Shadow the `}<inlineCode parentName="p">{`src/gatsby-theme-system/header.mdx`}</inlineCode>{` and `}<inlineCode parentName="p">{`src/gatsby-theme-system/footer.mdx`}</inlineCode>{` files to customize the content in the header and footer.`}</p>
    <p>{`MIT License`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      